import { render } from "./PromptDetail.vue?vue&type=template&id=7262c60d&scoped=true"
import script from "./PromptDetail.vue?vue&type=script&lang=js"
export * from "./PromptDetail.vue?vue&type=script&lang=js"

import "./PromptDetail.vue?vue&type=style&index=0&id=7262c60d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7262c60d"]])

export default __exports__